import { BrowserRouter } from "react-router-dom";
import App from "./App";

import React from "react";
import ReactDOM from "react-dom/client";
import './styles/theme.css'; // Asegúrate de que el archivo exista

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);